export type PermissoesAppInforcfc = {
  isAdmin: boolean;
  homePage: boolean;
  aluno: boolean;
  aulas: boolean;
  exames: boolean;
  recibos: boolean;
  bancoDigital: boolean;
  despesas_receitas: boolean;
  despesas: boolean;
  matriculas: boolean;
  marketing: boolean;
  marketingNovoModelo: boolean;
  protocolosProdesp: boolean;
  home: PermissonsCards;
  abrirAlunoPerfil: boolean;
  alunoPerfil: PermissoesPerfilAluno;
};

export type PermissonsCards = {
  MatriculaMes: boolean;
  Aulas: boolean;
  Receita: boolean;
  // Despesa: boolean;
  Matriculas: boolean;
  Fechamentos: boolean;
  CustoVeiculos: boolean;
  AulasVeiculos: boolean;
  // Tempo: boolean;
  MatriculasMetas: boolean;
  TodasUnidades: boolean;
  CarnesAtrasados: boolean;
  NotaFiscalRelPeriodo: boolean;
  ContratoOnline: boolean;
  RelatorioCobrancaOnline: boolean;
  Orcamentos: boolean;
};

export type PermissoesPerfilAluno = {
  contato: boolean;
  ladv: boolean;
  aulas: boolean;
  agendamentos: boolean;
  financeiro: boolean;
};

export enum PermissoesAppEnum {
  isAdmin = 'isAdmin',
  aluno = 'aluno',
  aulas = 'aulas',
  exames = 'exames',
  recibos = 'recibos',
  bancoDigital = 'bancoDigital',
  despesas_receitas = 'despesas_receitas',
  despesas = 'despesas',
  matriculas = 'matriculas',
  marketing = 'marketing',
  marketingNovoModelo = 'marketingNovoModelo',
  protocolosProdesp = 'protocolosProdesp',
  homePage = 'homePage',
  homeMatriculaMes = 'home.MatriculaMes',
  homeAulas = 'home.Aulas',
  homeReceita = 'home.Receita',
  homeDespesa = 'home.Despesa',
  homeMatriculas = 'home.Matriculas',
  homeFechamentos = 'home.Fechamentos',
  homeCustoVeiculos = 'home.CustoVeiculos',
  homeAulasVeiculos = 'home.AulasVeiculos',
  homeTempo = 'home.Tempo',
  homeMatriculasMetas = 'home.MatriculasMetas',
  homeTodasUnidades = 'home.TodasUnidades',
  homeCarnesAtrasados = 'home.CarnesAtrasados',
  homeNotaFiscalRelPeriodo = 'home.NotaFiscalRelPeriodo',
  homeContratoOnline = 'home.ContratoOnline',
  homeRelatorioCobrancaOnline = 'home.RelatorioCobrancaOnline',
  homeOrcamentos = 'home.Orcamentos',
  abrirAlunoPerfil = 'abrirAlunoPerfil',
  alunoPerfilContato = 'alunoPerfil.contato',
  alunoPerfilLadv = 'alunoPerfil.ladv',
  alunoPerfilAulas = 'alunoPerfil.aulas',
  alunoPerfilAgendamentos = 'alunoPerfil.agendamentos',
  alunoPerfilFinanceiro = 'alunoPerfil.financeiro',
}
